// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6afc8b74","239":"470bce93","453":"b202f617","667":"59071289"}[chunkId] + ".chunk.js";
};